import { extractJsonFieldSql } from './extractJsonFieldSql';
import { DirectionEnum } from '../enums/DirectionEnum';
import { OrderByInterface } from '../interfaces/OrderByInterface';
import { LocalesEnum } from '../enums/LocalesEnum';

export function buildNumericOrder(
    order: OrderByInterface[],
    rawName: LocalesEnum,
): string[] {
    return  order.length ? ['cast(' + order.reverse().reduce((acc, curr) => {
        return extractJsonFieldSql('attributes', `$.${curr.id}.${rawName}[0]`, acc);
    },  order[0].direction === DirectionEnum.ASC ? `'9999999'` : `'-9999999'`) + `as float) ${order[0].direction}`] : [];
}

export function buildPriceOrder(
    order: OrderByInterface[],
    rawName: LocalesEnum,
): string[] {
    if (order.length === 0) {
        return [];
    }
    const field = order.reverse().reduce((acc, curr) => {
        return extractJsonFieldSql('attributes', `$.${curr.id}.${rawName}[0]`, acc);
    },  order[0].direction === DirectionEnum.ASC ? `'9999999'` : `'-9999999'`);
    return  [`cast(TRIM(SUBSTR(${field}, INSTR(${field}, ' ') + 1)) as float) ${order[0].direction}`];
}

export function buildStringOrder(
    order: OrderByInterface[],
    rawName: LocalesEnum,
): string[] {
    return order.length ? [order.reverse().reduce((acc, curr) => {
        return extractJsonFieldSql('attributes', `$.${curr.id}.${rawName}[0]`, acc);
    }, order[0].direction === DirectionEnum.ASC ? `char(65535)` : `char(0)`) + ` ${order[0].direction}`] : [];

}
